import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "../i18n/I18nContext";
import SectionHead from "../components/SectionHead";

const ease = [0.16, 1, 0.3, 1];

export default function Definition() {
  const { t } = useI18n();
  return (
    <section
      id="definition"
      className="section border-t hair"
      data-testid="definition-section"
    >
      <div className="container-edge">
        <SectionHead
          kana={t.sections.definition.kana}
          roman={t.sections.definition.roman}
          right={<span className="mono" style={{ color: "var(--faded)" }}>fig. 01</span>}
        />

        <div className="grid grid-cols-12 gap-y-12 md:gap-x-10">
          {/* left: heading */}
          <motion.div
            className="col-span-12 md:col-span-5"
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease }}
          >
            <h2
              className="display text-[40px] sm:text-[56px] md:text-[72px] lg:text-[88px]"
              data-testid="definition-heading"
            >
              {t.definition.heading}
            </h2>
          </motion.div>

          {/* right: body + spec */}
          <motion.div
            className="col-span-12 md:col-span-6 md:col-start-7"
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease, delay: 0.1 }}
          >
            <p
              className="text-[18px] md:text-[22px] leading-[1.4] mb-6 md:mb-8"
              style={{ color: "var(--ink)", fontWeight: 300 }}
              data-testid="definition-kicker"
            >
              {t.definition.kicker}
            </p>
            <p className="body-text mb-10 md:mb-12">{t.definition.body}</p>

            {Array.isArray(t.definition.paragraphs) && (
              <div className="space-y-6 md:space-y-8 mb-12 md:mb-16" data-testid="definition-paragraphs">
                {t.definition.paragraphs.map((p, i) => (
                  <p key={i} className="body-text">{p}</p>
                ))}
              </div>
            )}

            {/* spec rows */}
            <dl
              className="border-t hair"
              data-testid="definition-spec"
            >
              {t.definition.spec.map((s, i) => (
                <div
                  key={i}
                  className="grid grid-cols-12 gap-4 border-b hair py-4"
                >
                  <dt className="mono col-span-3" style={{ color: "var(--faded)", paddingTop: "2px" }}>
                    {s.k}
                  </dt>
                  <dd className="col-span-9 m-0 text-[14px] md:text-[15px]" style={{ color: "var(--ink)" }}>
                    {s.v}
                  </dd>
                </div>
              ))}
            </dl>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
